var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"chart"}},[_c('apexchart',{attrs:{"height":"245","type":"donut","options":_vm.chartOptions,"series":_vm.chartOptions.series}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }